import { CORPORATE_CASES } from "../CorporatePortalContent";

export default function CorporateCasesPage() {
  return (
    <>
      <section className="corporate-page-banner">
        <div className="corporate-page-banner-inner">
          <h1 className="corporate-page-banner-title">成功案例</h1>
          <p className="corporate-page-banner-desc">
            真实陪跑、真实落地，帮助客户在 AI 组织转型、知识传播与内容创作上取得可衡量进展。
          </p>
        </div>
      </section>

      <div className="corporate-page">
        <section className="corporate-section" style={{ paddingTop: 40 }}>
          <div className="corporate-card-grid">
            {CORPORATE_CASES.map((item) => (
              <div key={item.id} className="corporate-card">
                <div className="corporate-tag-list" style={{ marginTop: 0, marginBottom: 12 }}>
                  <span className="corporate-tag">{item.industry}</span>
                </div>
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.client}</p>
                <p className="corporate-card-text" style={{ marginTop: 12, color: "#0b3d91" }}>
                  {item.result}
                </p>
                <p className="corporate-card-text" style={{ marginTop: 12 }}>
                  {item.detail}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
